import axiosInstance from "./axiosConfig";

export const sendSupportEmail = async (formData: FormData) => {
    const response = await axiosInstance.post('/support/email', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response?.data;
};
